import { showSuccess, showError, handleResponseErrors } from 'utils/messages';
import { trimMoney } from 'utils/strings';

import Base from 'app/views/base';
import tmpl from 'templates/recharge_settings';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .dropdown-item': 'updateDropdownAttribute',
  },

  initialize({ priority }) {
    this.priority = priority;
    this.listenTo(this.model, 'change', this.render);
  },

  context() {
    const roundToCents = (model, attr) => parseFloat(model.get(attr)) * 100;
    const trimAttr = (model, attr) => trimMoney(model.get(attr) || '', 'USD').split('.')[0];

    return {
      priority: this.priority,
      recharge_amount: trimAttr(this.model, 'recharge_amount'),
      secondary_recharge_amount: trimAttr(this.model, 'secondary_recharge_amount'),
      recharge_threshold: trimAttr(this.model, 'recharge_threshold'),

      recharge_amount_cents: roundToCents(this.model, 'recharge_amount'),
      secondary_recharge_amount_cents: roundToCents(this.model, 'secondary_recharge_amount'),
      recharge_threshold_cents: roundToCents(this.model, 'recharge_threshold'),

      recharge_amount_options_dollars: [20, 100, 250, 500, 1000, 2000, 5000, 10000],
      secondary_recharge_amount_options_dollars: [20, 50, 100, 250, 500, 1000, 2500],
      recharge_threshold_options_dollars: [0, 25, 50, 100, 250, 500, 1000, 2000, 5000],
    };
  },

  updateDropdownAttribute(e) {
    e.preventDefault();
    const attributeName = $(e.target).data('attribute');
    const attributes = { [attributeName]: ($(e.target).data('amount') / 100).toFixed(2) };
    this.model.update(attributes, {
      success() {
        showSuccess('Setting updated');
      },
      error(model, response) {
        handleResponseErrors(response, errors => {
          const error = errors.find(fieldError => fieldError.field === attributeName);
          showError(error.message);
        });
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/recharge_settings_view.js